import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { defineConfig , loadEnv} from 'vite'
import { useAuthFacade } from '@/auth/facade/authFacade'
import { redirectToClientLogin } from '@/auth/redirect/authRedirect'
import { logger } from '@myorg/type-lib'

import SidebarLayout from '@/layouts/SidebarLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'

import { loginRoute } from './auth/loginRoute'

import { inventoryRoute } from './inventory/inventoryRoute'
import { inventoryRoute2 } from './inventory/inventoryRoute2'

import { blogRoute } from './blog/blogRoute'
import { userRoute as userRoute } from './auth/userRoute'
import { MenuDesignRoute  } from './menu/menuDesignRoute'
import { ReportDesignRoute } from './report/reportDesignRoute'
import { AdRoute  } from './demo/ad'
import { DemoRoute  } from './demo/demo'
import { deleteRoute  } from './auth/delete'
import { privacyRoute  } from './auth/privacy'
import { termsOfServiceRoute  } from './auth/termOfService'

import { menuRoute } from './menu/menuRoute'
import { menuOrderRoute } from './menu/menuOrderRoute'
import { TablePostRoute } from './menu/tablePostRoute'
import { paymentRoute } from './payment/payment'
import { paymentSuccessRoute } from './payment/paymentSuccess'
import { orderManagementRoute } from './order/orderManagementRoute'
import { merchantOrderRoute } from './order/merchantOrderRoute'
import { bookingRoute } from './booking/bookingRoute'
import { bookingOrderRoute } from './booking/bookingRoute2'
import { reservationRoute } from './booking/bookingRoute3'
import { bookingActionRoute } from './booking/orderConfirm'
import { r2Route } from './r2/r2'
import { EcpayPaymentRoute } from './report/ecpayRoute'

import { ROUTES } from '@myorg/type-lib'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const IS_APP_BUILD = import.meta.env.VITE_BUILD_TARGET === 'app';

const routes: Array<RouteRecordRaw> = [
  // 🔐 不要 Sidebar 的頁面
  {
    path: ROUTES.HOME,
    component: EmptyLayout,
    children: [
      { 
        path: '', 
        redirect: ROUTES.USER.PATH
      },
      // {
      //   path: ROUTES.LOGIN.PATH,
      //   component: Login,
      // },
      bookingActionRoute,
      bookingOrderRoute,
      loginRoute,
      menuOrderRoute,
      paymentRoute,
      paymentSuccessRoute,
      ...(!IS_APP_BUILD ? [AdRoute, DemoRoute] : []),
      deleteRoute,
      privacyRoute,
      termsOfServiceRoute,
    ],
  },
  {
    path: ROUTES.HOME,
    component: SidebarLayout,
    meta: { requiresAuth: true },
    children: [
      { 
        path: '', 
        redirect: ROUTES.USER.PATH
      },
      // { path: ROUTES.LOGIN.PATH, component: Login },

      // { path: ROUTES.USER.PATH, component: UserPage },
      // BlogPostRoute,
      // { 
      //   name: ROUTES.POST_DETAIL.NAME,
      //   path: ROUTES.POST_DETAIL.PATH, 
      //   component: PostDetail, props: true 
      // },
      r2Route,
      reservationRoute,
      bookingRoute,
      userRoute,
      blogRoute,
      inventoryRoute,
      inventoryRoute2,
      MenuDesignRoute,
      ReportDesignRoute,
      EcpayPaymentRoute,
      // menuRoute,
      // menuOrderRoute,
      TablePostRoute,
      orderManagementRoute,
      merchantOrderRoute,
    ],
  },
]

// const base =
//   import.meta.env.VITE_APP_HOME_PATH ?? '/'

const router = createRouter({
  history: createWebHistory(),
  // history: createWebHistory(base),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始終捲動到頂部
    return { top: 0 }
  },
})

router.beforeEach(async (to, from, next) => {
  try {
    const auth = useAuthFacade()

    // Login 頁特殊處理
    if (to.path === ROUTES.LOGIN.PATH) {
      // 已登入，不准再進 login
      if (auth.isLoggedIn) {
        return next({ path: ROUTES.USER.PATH })
      }

      // 未登入，直接放行，不做 checkAuth/login
      return next()
    }

    // 其他頁面才檢查登入
    const requiresAuth = to.matched.some(
      record => record.meta.requiresAuth
    )

    if (requiresAuth && !auth.isLoggedIn) {
      const ok = await auth.checkAuth()

      if (!ok) {
        await auth.login()
        return next(false)
      }

      // 補 localStorage
      logger.log('[Router guard] auth state restored')
    }

    return next()
  } catch (err) {
    console.error('[Router guard error]', err)

    return next()
  }
})

export default router
